import { StyledVideoLink } from '@/components/styles'

export default function VideoLink({ href, title }) {
  return (
    <StyledVideoLink target="_blank" rel="noopener noreferrer" href={href}>
      <StyledVideoLink.Icon />
      {title}
    </StyledVideoLink>
  )
}
